module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "surveillance-device"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.deviceInfo
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "120"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.label) + "\n      ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Usage",
      "width": "200"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "Not Selected"
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "220",
      "label": "Start Date"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-date-picker', {
          attrs: {
            "type": "date",
            "readonly": "",
            "editable": "",
            "clearable": "",
            "format": "dd-MM-yyyy"
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "220",
      "label": "End Date"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-date-picker', {
          attrs: {
            "type": "date",
            "readonly": "",
            "editable": "",
            "clearable": "",
            "format": "dd-MM-yyyy"
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Duration"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-720d8c48!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/SurveillanceDevice.vue
// module id = 250
// module chunks = 2